import { render, staticRenderFns } from "./termsConditons.vue?vue&type=template&id=61b0a6de"
import script from "./termsConditons.vue?vue&type=script&lang=js"
export * from "./termsConditons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports